import Vue from 'vue'

const NotFound404 = Vue.component('my-component', {
  functional: true,
  render: function (createElement, context) {
    return createElement('div', 'Sorry, nothing to see here.')
  }
})

export default NotFound404



// WEBPACK FOOTER //
// ./src/components/404.js